<div *ifSize="'XL'"
     class="p-l-10 p-r-10 p-t-5 p-b-5 flex"
     style="gap: 20px"
     [ngClass]="data.specialMenuBackgroundColor || 'bg-col-53'">
    @for(item of data.specialMenuItems.slice(0,3); track $index) {
    <div class="w-12 p-l-5 p-r-5 pos-relative"
         style="height: 282px;"
         [ngClass]="(!item.backgroundImage && (item.backgroundColor || 'bg-col-w')) + ' ' + (item.color || 'col-1')">
        @if(item?.backgroundImage){
        <img class="fill z-1"
             [image]="item?.backgroundImage">
        }
        <href class="fill z-2 center flex flex-column flex-justify-center flex-middle"
              [link]="item.ctaLink"
              [hrefClass]="'fill flex flex-column flex-justify-center flex-middle'">
            @if(item?.topText){
            <p class="p3"
               *iCms="'topText' of item"></p>
            }
            <p class="h2 m-t-1"
               *iCms="'title' of item"></p>
            @if(item?.bottomText){
            <p class="p2 m-t"
               *iCms="'bottomText' of item"></p>
            }
            @if(item.ctaLink && item.ctaText){
            <button class="button m-t"
                    type="button"
                    *iCms="'ctaText' of item">
            </button>
            }
        </href>
    </div>
    }
</div>
<div *ifSize="'MS'"
     [ngClass]="data.specialMenuBackgroundColor || 'bg-col-53'"
     class="p-t-5 p-b-5 p-a">
    <carousel [slidesPerView]="1"
              [loop]="true"
              [enabled]="data.specialMenuItems && data.specialMenuItems.length > 1 ? true : false"
              [navigation]="{
                         nextEl: '.special-menu-next',
                         prevEl: '.special-menu-prev'
                    }">
        @for(item of data.specialMenuItems || []; track $index) {
        <ng-template swiperSlide>
            <img class="z-1 fill"
                 [image]="item?.backgroundImage">
            <div class="w-12 z-2 center flex flex-column flex-justify-center flex-middle p-l-5 p-r-5 pos-relative"
                 style="height: 248px;"
                 [ngClass]="(!item?.backgroundImage && (item?.backgroundColor || 'bg-col-w')) + ' ' + (item?.color || 'col-1')">
                @if(item?.topText){
                <p class="p3"
                   *iCms="'topText' of item"></p>
                }
                <p class="h2 m-t-1"
                   *iCms="'title' of item"></p>
                @if(item?.bottomText){
                <p class="p2 m-t"
                   *iCms="'bottomText' of item"></p>
                }
                @if(item.ctaLink && item.ctaText){
                <href [link]="item.ctaLink"
                      class="inline-block m-t">
                    <button class="button"
                            type="button"
                            *iCms="'ctaText' of item"></button>
                </href>
                }
                @if(item.ctaLink){
                <href [link]="item.ctaLink">
                    <span class="fill z-3"></span>
                </href>
                }

                <!-- navigation -->
                <button class="pos-absolute top-50 left-4 z-5 special-menu-prev"
                        type="button"
                        [ngClass]="item?.color || 'col-1'"
                        [attr.aria-label]="'Previous slide' | translate">
                    <i class="icon-chevron-left"
                       style="font-size: 12px;"
                       aria-hidden="true"></i>
                </button>
                <button class="pos-absolute top-50 right-4 z-5 special-menu-next"
                        type="button"
                        [ngClass]="item?.color || 'col-1'"
                        [attr.aria-label]="'Next slide' | translate">
                    <i class="icon-chevron-right"
                       style="font-size: 12px;"
                       aria-hidden="true"></i>
                </button>
            </div>
        </ng-template>
        }
    </carousel>
</div>